<template>
	<v-dialog
		v-model="visible"
		max-width="500"
		persistent
	>
		<v-alert
			class="mb-0 px-8"
			:border="'top'"
			colored-border
			color="info"
		>
			<v-row class="my-0">
				<div class="title-text">Edit recurring event</div>
			</v-row>
			<v-row class="my-0">
				<v-col cols="12" class="pa-0">
					<v-alert class="mt-4" type="error" dense v-if="error_msg.length !== 0">
						{{ error_msg }}
					</v-alert>
				</v-col>
			</v-row>
			<v-row class="mt-2">
				<v-radio-group
					style="margin-top: 0; padding-top: 0;"
					v-model="mode"
					dense
					mandatory
				>
					<v-radio
						:value="0"
						:color="color"
					>
						<template v-slot:label>
							<span class="item-text">
								This and following events
							</span>
						</template>
					</v-radio>
					<v-radio
						:value="1"
						:color="color"
					>
						<template v-slot:label>
							<span class="item-text">
								This event only
							</span>
						</template>
					</v-radio>
					
				</v-radio-group>
			</v-row>
			<v-row class="mt-0 mb-2" justify="center">
				<v-btn outlined class="text-capitalize" @click="$emit('cancel')">Cancel</v-btn>
				<v-btn 
					depressed 
					color="#00AAFD" 
					class="ml-2 white--text text-capitalize" 
					@click="$emit('submit', mode)">
					<span>Save</span>
				</v-btn>
			</v-row>
		</v-alert>
	</v-dialog>
</template>

<script>
export default {
	name: 'RecurringComfirmDialog',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		color: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			error_msg: '',
			mode: 0, /** 0 - this event forward(default); 1 - this event only */
		}
	},
}
</script>

<style lang="scss" scoped>
.title-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: #192A3E;
}
.item-text {
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: rgba(55, 73, 95, 1);
}
</style>

